<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense flat rounded="" color="secondary" outlined elevation="1">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & inventory'}, {text: 'Warehouse'} ,{text: 'Warehouse List',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet elevation="1">
                    <v-toolbar color="secondary" flat>
                        <v-toolbar-title>
                            Warehouses
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-plus" tooltip="New Warehouse" @click="handleNew" v-if="hasPermission(perm.warehouse.create)"/>
                            <PIconBtn icon="mdi-refresh" tooltip="Refresh" @click="search"/>
                            <v-menu 
                                left
                                absolute 
                                :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <v-card 
                                    flat
                                    >
                                    <v-card-title>Search</v-card-title>
                                    <v-card-text>
                                        <WarehouseListSearch ref="form"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <WarehouseList/>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import WarehouseListSearch from './../../components/warehouse/WarehouseListSearch.vue'
import WarehouseList from './../../components/warehouse/WarehouseList.vue'
import PIconBtn from './../../components/common/PIconBtn.vue';
import { mapActions, mapGetters } from 'vuex';
import permissions from './../../data/permissions'
export default {
    name: "WarehouseListView",
    components: {
        PIconBtn,
        WarehouseList,
        WarehouseListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "WarehouseCreate"})
        },
        ...mapActions({
            search: "warehouse/warehouse/list/search"
        }),
    }
}
</script>

<style>
</style>